/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserIdDto } from './UserIdDto';
import {
    UserIdDtoFromJSON,
    UserIdDtoFromJSONTyped,
    UserIdDtoToJSON,
} from './UserIdDto';

/**
 * 
 * @export
 * @interface ConfirmDeleteUserDto
 */
export interface ConfirmDeleteUserDto {
    /**
     * 
     * @type {UserIdDto}
     * @memberof ConfirmDeleteUserDto
     */
    userId: UserIdDto;
}

/**
 * Check if a given object implements the ConfirmDeleteUserDto interface.
 */
export function instanceOfConfirmDeleteUserDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "userId" in value;

    return isInstance;
}

export function ConfirmDeleteUserDtoFromJSON(json: any): ConfirmDeleteUserDto {
    return ConfirmDeleteUserDtoFromJSONTyped(json, false);
}

export function ConfirmDeleteUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmDeleteUserDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': UserIdDtoFromJSON(json['userId']),
    };
}

export function ConfirmDeleteUserDtoToJSON(value?: ConfirmDeleteUserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': UserIdDtoToJSON(value.userId),
    };
}

